// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v6.31.1
// source: Common/EventService.proto

/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { Any } from "../google/protobuf/any";
import { Empty } from "../google/protobuf/empty";
import { Timestamp } from "../google/protobuf/timestamp";

export const protobufPackage = "common.events";

export enum ChannelType {
  DEVICE = 0,
  ADMIN = 1,
  UNRECOGNIZED = -1,
}

export function channelTypeFromJSON(object: any): ChannelType {
  switch (object) {
    case 0:
    case "DEVICE":
      return ChannelType.DEVICE;
    case 1:
    case "ADMIN":
      return ChannelType.ADMIN;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ChannelType.UNRECOGNIZED;
  }
}

export function channelTypeToJSON(object: ChannelType): string {
  switch (object) {
    case ChannelType.DEVICE:
      return "DEVICE";
    case ChannelType.ADMIN:
      return "ADMIN";
    case ChannelType.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface SubscriptionRequest {
  /** GUID */
  sessionId: string;
  channel: ChannelType;
  institutionId?: string | undefined;
}

export interface EventMessage {
  /** GUID */
  messageId: string;
  sessionId: string;
  channel: ChannelType;
  eventType: string;
  eventData: Any | undefined;
  createdAt: Date | undefined;
  expiresAt: Date | undefined;
  deviceId: string;
  institutionId?: string | undefined;
}

function createBaseSubscriptionRequest(): SubscriptionRequest {
  return { sessionId: "", channel: 0, institutionId: undefined };
}

export const SubscriptionRequest = {
  encode(message: SubscriptionRequest, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.sessionId !== "") {
      writer.uint32(10).string(message.sessionId);
    }
    if (message.channel !== 0) {
      writer.uint32(16).int32(message.channel);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(34).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): SubscriptionRequest {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSubscriptionRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        case 2:
          if (tag !== 16) {
            break;
          }

          message.channel = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SubscriptionRequest {
    return {
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      channel: isSet(object.channel) ? channelTypeFromJSON(object.channel) : 0,
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: SubscriptionRequest): unknown {
    const obj: any = {};
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.channel !== 0) {
      obj.channel = channelTypeToJSON(message.channel);
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<SubscriptionRequest>): SubscriptionRequest {
    return SubscriptionRequest.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<SubscriptionRequest>): SubscriptionRequest {
    const message = createBaseSubscriptionRequest();
    message.sessionId = object.sessionId ?? "";
    message.channel = object.channel ?? 0;
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

function createBaseEventMessage(): EventMessage {
  return {
    messageId: "",
    sessionId: "",
    channel: 0,
    eventType: "",
    eventData: undefined,
    createdAt: undefined,
    expiresAt: undefined,
    deviceId: "",
    institutionId: undefined,
  };
}

export const EventMessage = {
  encode(message: EventMessage, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.messageId !== "") {
      writer.uint32(10).string(message.messageId);
    }
    if (message.sessionId !== "") {
      writer.uint32(18).string(message.sessionId);
    }
    if (message.channel !== 0) {
      writer.uint32(24).int32(message.channel);
    }
    if (message.eventType !== "") {
      writer.uint32(34).string(message.eventType);
    }
    if (message.eventData !== undefined) {
      Any.encode(message.eventData, writer.uint32(42).fork()).ldelim();
    }
    if (message.createdAt !== undefined) {
      Timestamp.encode(toTimestamp(message.createdAt), writer.uint32(50).fork()).ldelim();
    }
    if (message.expiresAt !== undefined) {
      Timestamp.encode(toTimestamp(message.expiresAt), writer.uint32(58).fork()).ldelim();
    }
    if (message.deviceId !== "") {
      writer.uint32(74).string(message.deviceId);
    }
    if (message.institutionId !== undefined) {
      writer.uint32(82).string(message.institutionId);
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): EventMessage {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseEventMessage();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.messageId = reader.string();
          continue;
        case 2:
          if (tag !== 18) {
            break;
          }

          message.sessionId = reader.string();
          continue;
        case 3:
          if (tag !== 24) {
            break;
          }

          message.channel = reader.int32() as any;
          continue;
        case 4:
          if (tag !== 34) {
            break;
          }

          message.eventType = reader.string();
          continue;
        case 5:
          if (tag !== 42) {
            break;
          }

          message.eventData = Any.decode(reader, reader.uint32());
          continue;
        case 6:
          if (tag !== 50) {
            break;
          }

          message.createdAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 7:
          if (tag !== 58) {
            break;
          }

          message.expiresAt = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
          continue;
        case 9:
          if (tag !== 74) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        case 10:
          if (tag !== 82) {
            break;
          }

          message.institutionId = reader.string();
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): EventMessage {
    return {
      messageId: isSet(object.messageId) ? globalThis.String(object.messageId) : "",
      sessionId: isSet(object.sessionId) ? globalThis.String(object.sessionId) : "",
      channel: isSet(object.channel) ? channelTypeFromJSON(object.channel) : 0,
      eventType: isSet(object.eventType) ? globalThis.String(object.eventType) : "",
      eventData: isSet(object.eventData) ? Any.fromJSON(object.eventData) : undefined,
      createdAt: isSet(object.createdAt) ? fromJsonTimestamp(object.createdAt) : undefined,
      expiresAt: isSet(object.expiresAt) ? fromJsonTimestamp(object.expiresAt) : undefined,
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      institutionId: isSet(object.institutionId) ? globalThis.String(object.institutionId) : undefined,
    };
  },

  toJSON(message: EventMessage): unknown {
    const obj: any = {};
    if (message.messageId !== "") {
      obj.messageId = message.messageId;
    }
    if (message.sessionId !== "") {
      obj.sessionId = message.sessionId;
    }
    if (message.channel !== 0) {
      obj.channel = channelTypeToJSON(message.channel);
    }
    if (message.eventType !== "") {
      obj.eventType = message.eventType;
    }
    if (message.eventData !== undefined) {
      obj.eventData = Any.toJSON(message.eventData);
    }
    if (message.createdAt !== undefined) {
      obj.createdAt = message.createdAt.toISOString();
    }
    if (message.expiresAt !== undefined) {
      obj.expiresAt = message.expiresAt.toISOString();
    }
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.institutionId !== undefined) {
      obj.institutionId = message.institutionId;
    }
    return obj;
  },

  create(base?: DeepPartial<EventMessage>): EventMessage {
    return EventMessage.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<EventMessage>): EventMessage {
    const message = createBaseEventMessage();
    message.messageId = object.messageId ?? "";
    message.sessionId = object.sessionId ?? "";
    message.channel = object.channel ?? 0;
    message.eventType = object.eventType ?? "";
    message.eventData = (object.eventData !== undefined && object.eventData !== null)
      ? Any.fromPartial(object.eventData)
      : undefined;
    message.createdAt = object.createdAt ?? undefined;
    message.expiresAt = object.expiresAt ?? undefined;
    message.deviceId = object.deviceId ?? "";
    message.institutionId = object.institutionId ?? undefined;
    return message;
  },
};

export type EventServiceDefinition = typeof EventServiceDefinition;
export const EventServiceDefinition = {
  name: "EventService",
  fullName: "common.events.EventService",
  methods: {
    subscribe: {
      name: "Subscribe",
      requestType: SubscriptionRequest,
      requestStream: false,
      responseType: EventMessage,
      responseStream: true,
      options: {},
    },
    unsubscribe: {
      name: "Unsubscribe",
      requestType: SubscriptionRequest,
      requestStream: false,
      responseType: Empty,
      responseStream: false,
      options: {},
    },
    /** todo remove it */
    publish: {
      name: "Publish",
      requestType: EventMessage,
      requestStream: false,
      responseType: Empty,
      responseStream: false,
      options: {},
    },
  },
} as const;

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function toTimestamp(date: Date): Timestamp {
  const seconds = Math.trunc(date.getTime() / 1_000);
  const nanos = (date.getTime() % 1_000) * 1_000_000;
  return { seconds, nanos };
}

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new globalThis.Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof globalThis.Date) {
    return o;
  } else if (typeof o === "string") {
    return new globalThis.Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
